import { render, staticRenderFns } from "./ModalInformacoes.vue?vue&type=template&id=1878bc7a&scoped=true"
import script from "./ModalInformacoes.vue?vue&type=script&lang=js"
export * from "./ModalInformacoes.vue?vue&type=script&lang=js"
import style0 from "./ModalInformacoes.vue?vue&type=style&index=0&id=1878bc7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1878bc7a",
  null
  
)

export default component.exports